/**
 * 반품 사유 코드. 서버(`server/src/domain/return-reason.ts`)와 같은 목록이어야 한다.
 * 문구는 언어 사전의 `reason.*` 가 정한다.
 */
export const RETURN_REASONS = [
  "change_of_mind",
  "defect",
  "wrong_item",
  "damaged",
  "address_unknown",
  "other",
] as const

export type ReturnReason = (typeof RETURN_REASONS)[number]
